import { VideoSection, VideoSectionProps } from '@rimactechnology/rimac-ui-lib';

import { VideoSectionFragment } from '@/api';
import getCdlPublicId from '@/hooks/useCdlPublicId';

interface EnhancedVideoSectionProps {
  textCenter?: boolean;
  titleMaxWidth?: number;
  descriptionMaxWidth?: number;
  videoSection?: VideoSectionFragment | null;
}

export default function EnhancedVideoSection({
  textCenter,
  titleMaxWidth,
  descriptionMaxWidth,
  videoSection,
}: EnhancedVideoSectionProps) {
  const videoSectionProps: VideoSectionProps = {
    textCenter,
    titleMaxWidth,
    descriptionMaxWidth,
    bgColor: 'light-blue',
    anchor: videoSection?.anchor || undefined,
    title: videoSection?.title || '',
    description: videoSection?.description || '',
    button: {
      label: videoSection?.button?.label || '',
      path: videoSection?.button?.path || '',
      useCase: 'technology',
      openInNewTab: !!videoSection?.button?.openInNewTab,
    },
    video: {
      videoSrc: getCdlPublicId(
        videoSection?.video?.video?.data?.attributes?.url || '',
      ),
      posterSrc: getCdlPublicId(
        videoSection?.video?.poster?.data?.attributes?.url || '',
      ),
      posterAlt: videoSection?.video?.poster_alt || '',
      blurHash:
        videoSection?.video?.poster?.data?.attributes?.blurhash ||
        'LAS?DV%M_3D%t7fQofj[~qM{4n-;',
      controls: false,
      width: 1920,
      height: 734,
    },
  };

  return <VideoSection {...videoSectionProps} />;
}
